/** Shared chrome for expandable in-app agent tool-step detail panels (debug / audit, not deliverable cards). */
export const CHAT_TOOL_STEP_DETAIL_PANEL_CLASS =
  "mt-1 max-w-full rounded border border-slate-200/45 bg-slate-50/50 px-2 py-1.5 dark:border-slate-700/40 dark:bg-slate-900/25";

export const CHAT_TOOL_STEP_DETAIL_MUTED_CLASS =
  "text-[10px] leading-snug text-slate-500 dark:text-slate-500";
